<template>
  <div id="app" v-if="ready">
    <router-view/>


    <div class="alertbox auto" v-show="alert.show" @click="closeAlert">
      <div class="alertbox-content auto">
        <!-- <img src="./assets/alert-bg.png" alt=""> -->
        <div class="alert-message-box">
          <p v-html="alert.message"></p>
          <span>
            <!-- <img src="./assets/alert-btn-shop.png" v-if="alert.btnType === 'shop'" @click.stop="goMini(alert.path, alert.event_id)" alt=""> -->
            <!-- <img src="./assets/alert-btn.png" v-else @click="closeAlert" alt=""> -->
          </span>
        </div>
      </div>
    </div>

    <div class="loadingbox auto" v-show="loading">
      <div class="loading"></div>
    </div>

    <div class="sharebox auto" v-show="share" @click="closeShare">
      <!-- <img src="./assets/share-tips.png" alt=""> -->
    </div>

    <!-- <div class="clearInfo auto" @click="clearInfo">
      清除信息
    </div>

    <div class="clearInfo shareInfo auto" @click="testShare">
      模拟分享
    </div> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Config from './conf'
// import Tracker from './common/tracker'
import { Auth } from '@/model'
export default {
  data () {
    return {
      ready: true
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'alert',
      'loading',
      'share'
    ])
  },
  created () {
    this.getAuth()
    this.getSignature()
  },
  mounted () {
    this.setSize()
  },
  methods: {
    closeShare () {
      this.$store.dispatch('share', false)
    },
    closeAlert () {
      this.$store.dispatch('alert', {
        message: '',
        show: false,
        btnType: 'normal',
        path: '',
        event_id: ''
      })
    },
    async getAuth () {
      let search = this.$util.deserialize(window.location.search && window.location.search.slice(1))
      if (search['token']) {
        // let redirect = this.$cookie.get(Config.current_key)
        this.$cookie.set(Config.token_key, search['token'])
        // this.$cookie.delete(Config.current_key)
        delete search['token']
        var newSearch = this.$util.serialize(search)
        console.log(JSON.stringify(newSearch))
        var url = window.location.origin + window.location.pathname
        if (newSearch) {
          url += '?' + newSearch + window.location.hash
        } else {
          url += window.location.hash
        }
        console.log(url)
        console.log(window.location)
        window.location.href = url
      } else {
        let token = this.$cookie.get(Config.token_key)
        if (token) {
          // Tracker.init(token, function () {
          //   console.log('tracker init success')
          // })
          this.getUserInfo()
        } else {
          // alert('请通过正确渠道访问！')
        }
      }
    },
    async getUserInfo () {
      let res = await Auth.getUserInfo()
      if (!res['err_code']) {
        this.ready = true
        this.$store.dispatch('user', res['data'])
      }
    },
    async getSignature() {
      let res = await Auth.getSignature({
        url: encodeURIComponent(window.location.href),
      });
      if (res && !res["err_code"]) {
        this.$wx.config({
          debug: false,
          appId: res["data"]["appId"],
          timestamp: res["data"]["timestamp"],
          nonceStr: res["data"]["nonceStr"],
          signature: res["data"]["signature"],
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "hideMenuItems",
            "openLocation"
          ],
          openTagList: [
            'wx-open-launch-weapp'
          ] 
        });
        // proxy.$wx.ready(() => {
        //   proxy.$wx.hideMenuItems({
        //     menuList: [
        //       "menuItem:copyUrl",
        //       "menuItem:share:appMessage",
        //       "menuItem:share:timeline",
        //       "menuItem:share:qq",
        //       "menuItem:share:weiboApp",
        //       "menuItem:favorite",
        //       "menuItem:share:facebook",
        //       "menuItem:share:QZone",
        //       "menuItem:openWithQQBrowser",
        //       "menuItem:openWithSafari",
        //       "menuItem:share:email",
        //       "menuItem:share:brand",
        //     ], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        //   });
        //   proxy.$wx.onMenuShareTimeline({
        //     title: shareInfo.title, // 分享标题
        //     link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: shareInfo.imgUrl, // 分享图标
        //     success: () => {},
        //   });
        //   proxy.$wx.onMenuShareAppMessage({
        //     title: shareInfo.title, // 分享标题
        //     desc: shareInfo.desc, // 分享描述
        //     link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: shareInfo.imgUrl, // 分享图标
        //     success: () => {},
        //   });
        // });
      }
    },
    setSize () {
      var width = document.getElementsByTagName('body')[0].clientWidth
      var fontSize = 10 * width / 375 + 'px'
      document.getElementsByTagName('html')[0].style.fontSize = fontSize
    },
    goMini (path, event_id) {
      this.$wx.miniProgram.switchTab({
        url: path,
        success: function () {
          // 监控
          window.Tracker.push({
            type: event_id
          });
        },
      })
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  border: none;
  outline: none;
}
body,html {
  width: 100%;
  /* height: 100%; */
  font-family:  "Microsoft YaHei", "黑体", "SimHei", "PingFang SC", Arial;
  font-size: 10px;
  color: #000;
  background: #fff;
  /* background: url('assets/bg.jpg'); */
}
img[lazy=loading] {
  /*your style here*/
  width: 10vw;
  height: 10vw;
  position: absolute;
  left: 50%;
  top: 20vw;
  // margin-top: -5vw;
  margin-left: -5vw;
}
#app {
  width: 100%;
  overflow-x: hidden;
}
a{
  text-decoration: none;
  outline: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
  background: none;
}
img {
  display: block;
  width: 100%;
  height: auto;
}
div {
  box-sizing: border-box;
}
.auto {
  height: auto;
  overflow: hidden;
}
.flexbox {
  width: 100%;
  display: flex;
}
.flexbox>div:last-child {
  flex: 1;
  padding-top: 0;
  padding-bottom: 0;
}
.clear {
  width: 100%;
  height: 0px;
  overflow: hidden;
  clear: both;
}
.ellipsis{
  text-overflow: ellipsis;
  white-space: nowrap;
}

.alertbox {
  position: fixed;
  z-index: 99999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.alertbox-content {
  width: 84.8vw;
  position: relative;
}
.alertbox-content div.alert-message-box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.alertbox-content p {
  font-size: 1.6em;
  color: #194a4e;
  line-height: 1.4em;
  margin: 0 15% 0;
  text-align: center;
}
.alertbox-content span {
  display: inline-block;
  width: 32vw;
  margin-top: 6vw;
}

.loadingbox {
  position: fixed;
  z-index: 99999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading {
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 100%;

  animation: circle infinite 0.75s linear;
}

/* 转转转动画 */
@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.sharebox {
  position: fixed;
  z-index: 99999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .7);
}

.clearInfo {
  width: 20vw;
  height: 40px;
  text-align: center;
  line-height: 40px;
  position: fixed;
  right: 10vw;
  top: 10vw;
  background: #000;
  color: #fff;
}

.shareInfo {
  right: 40vw;
}

.word-page {
  padding: 5vw 3%;
}
.word-page pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}


.tips-alert {
	position: fixed;
	display: flex;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
	background: rgba(0, 0, 0, .76);
	z-index: 999;
	align-items: center;
	justify-content: center;
}
.tips-alert-content {
	width: 84%;
	.tips-title{
		height: 50px;
		background: #fff;
		text-align: center;
		line-height: 50px;
		font-size: 17px;
		color: #000;
	}
	.tips-content {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 15px;
		color: #000;
		background: #fff;
		padding: 0 10%;
		height: 115px;
		// text-align: center;
	}
	.tips-btn-box {
		display: flex;
		background: #fff;
		padding-bottom: 16px;
		justify-content: center;
		gap: 13px;
		.tips-btn {
			width: 35%;
			text-align: center;
			background: #c2d6f0;
			height: 40px;
			color: #000;
			font-size: 15px;
			line-height: 40px;
		}
		.cur {
			background: #e33521;
			color: #fff;
		}
	}
  .tips-btn-boxbetween {
    // justify-content: space-between;
    .tips-btn {
      margin: 0 3vw;
    }
  }
}
.tips-btn-cancel {
	background: #fff;
	text-align: center;
	color: #666;
	font-size: 12px;
	padding-bottom: 20px;
	text-decoration: underline;
}
</style>
